import { Form, useLocation, useNavigate } from "react-router-dom";
import FormControl from "react-bootstrap/FormControl";
import { useEffect } from "react";

import { useAuth } from "../../contexts/AuthContext";
import { LoginWithGoogleButton } from "../../components/LoginWithGoogleButton";
import { useForm } from "../../hooks/useForm";
import { useTitle } from "../../hooks/useTitle";

import "./auth.css";

export function LoginPage() {
    useTitle("Sign in");
    const { isAuthenticated, login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const from = params.get("from") || "/games";
    const resetSuccess = params.get("reset") === "success";

    useEffect(() => {
        if (isAuthenticated) {
            navigate(from);
        }
    }, [isAuthenticated, navigate, from]);

    const { handleSubmit, status, message } = useForm(login, () => {});

    return (
        <section className="mkt-auth">
            <div className="mkt-auth-mast">
                <div className="mkt-auth-mast-kicker">Sign in</div>
                <h1>
                    Pick up where the <em>last hand</em> left off.
                </h1>
                <p>
                    The host's book is right where you left it — players, balances,
                    every transaction reconciled.
                </p>
            </div>

            <div className="mkt-auth-card">
                {resetSuccess && (
                    <div className="mkt-auth-notice">
                        Your password has been reset. Sign in with your new password.
                    </div>
                )}
                <Form method="post" replace onSubmit={handleSubmit} className="mkt-auth-form">
                    <FormControl hidden={true} name="redirectTo" defaultValue={from} />
                    <div>
                        <label className="mkt-auth-label" htmlFor="login-email">Email</label>
                        <FormControl
                            id="login-email"
                            required
                            name="email"
                            type="email"
                            placeholder="you@example.com"
                        />
                    </div>
                    <div>
                        <label className="mkt-auth-label" htmlFor="login-password">Password</label>
                        <FormControl
                            id="login-password"
                            required
                            name="password"
                            type="password"
                            placeholder="••••••••"
                        />
                    </div>
                    <button type="submit">Sign in</button>
                    <div className="mkt-auth-forgot">
                        <a href="/forgot-password">Forgot password?</a>
                    </div>
                    <div className="mkt-auth-divider">or</div>
                    <LoginWithGoogleButton className="mkt-auth-google" />
                    {message && (
                        <div className="mkt-auth-error">
                            {status}: {message}
                        </div>
                    )}
                </Form>
                <div className="mkt-auth-foot">
                    New around here? <a href="/sign-up">Start a free ledger</a>
                </div>
            </div>
        </section>
    );
}
